import styled from 'styled-components';
import { badgeShadow, darkgrey, white } from 'styles/Colors';

export const HotkeyBadgeWrapper = styled.div`
  display: inline-block;
  padding: 0px 4px;
  min-width: 58px;
  border-radius: 5px;
  box-shadow: 0px 2px 0px ${badgeShadow};
  border: 1px solid ${badgeShadow};
  background-color: ${white};
  font-family: Lato;
  font-size: 13px;
  letter-spacing: 0.43px;
  text-align: center;
  color: ${darkgrey};
  width: fit-content;

  svg {
    width: 25px;
    height: 25px;
  }
`;
export const Text = styled.span`
  font-weight: 400;
  margin-right: 5px;
  text-transform: capitalize;
`;
export const Hotkey = styled.span`
  font-size: 15px;
  font-weight: 700;
  line-height: 17px;
`;
